<template>
  <div>
    <div class="mt-8">
      <h5><i class="dot"></i> 점검연도 <number-input v-model="form.점검연도" :useComma="false" :align="'left'" style="width: 114px; display: inline-block" class="mx-2" /><span>년</span></h5>

      <h5 class="mt-28px"><i class="dot"></i> 점검구분</h5>
      <div class="mt-4">
        <div class="flex items-center gap-4">
          <span style="min-width: 70px; font-weight: 500; font-size: 14px;">정기점검 :</span>
          <vs-checkbox :value="form.정기점검 === '상반기'" @input="form.정기점검 = $event ? '상반기' : ''" :disabled="board.readonly">상반기</vs-checkbox>
          <vs-checkbox :value="form.정기점검 === '하반기'" @input="form.정기점검 = $event ? '하반기' : ''" :disabled="board.readonly">하반기</vs-checkbox>
        </div>
        <div class="flex items-center gap-4 mt-2">
          <span style="min-width: 70px; font-weight: 500; font-size: 14px;">수시점검 :</span>
          <vs-checkbox :value="form.수시점검 === '해빙기'" @input="form.수시점검 = $event ? '해빙기' : ''" :disabled="board.readonly">해빙기</vs-checkbox>
          <vs-checkbox :value="form.수시점검 === '우수기'" @input="form.수시점검 = $event ? '우수기' : ''" :disabled="board.readonly">우수기</vs-checkbox>
          <vs-checkbox :value="form.수시점검 === '동절기'" @input="form.수시점검 = $event ? '동절기' : ''" :disabled="board.readonly">동절기</vs-checkbox>
          <vs-checkbox :value="form.수시점검 === '기타'" @input="form.수시점검 = $event ? '기타' : ''" :disabled="board.readonly">기타</vs-checkbox>
        </div>
      </div>
    </div>

    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" class="mt-28px" :useFieldInfo="false" />

    <!-- 점검개요 -->
    <div class="mb-4">
      <div>
        <h5><i class="dot"></i>점검개요</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>조치기간</div>
        <div class="flex">
          <date-selector-rang v-model="form.조치기간" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>조치대상 시설</div>
        <div class="flex flex-1 items-center">
          <div v-if="isPrint" class="print-textarea">{{ form.조치대상시설.join(",") }}</div>
          <field-selector class="w-full" multiple v-model="form.조치대상시설"></field-selector>
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>조치담당자</div>
        <div>
          <ml-input v-model="form.조치담당자" placeholder="홍길동" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>조치내용</div>
        <div>
          <ml-textarea v-model="form.조치내용" rows="5" placeholder="조치내용" />
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
    NumberInput,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
                if (key === "정기점검" || key === "수시점검") {
              const v = value[key];
              this.form[key] = Array.isArray(v) ? (v[0] || "") : (v || "");
            } else {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        점검연도: new Date().getFullYear(),
        정기점검: "",
        수시점검: "",

        stdInfo: {},
        fileList: [],
        조치기간: {},
        조치대상시설: [],
        조치담당자: "",
        조치내용: "",
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
